import { useEffect, useState } from 'react'
import './App.css';
import MainBody from './components/MainBody/MainBody';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Table from './components/MainBody/Tabel';


function App() {
  // const [Login, setLogin] = useState(true)
 
  // useEffect(() => {
  //  let pin = JSON.parse(sessionStorage.getItem("pin"))
  //  if(pin != null){
  //   setLogin(true)
  //  }
  // }, [])

  return (
    <div className="App">
      <Header />
      {/* <MainBody Login={Login} setLogin={setLogin}/> */}
      <Table/>
      <Footer />
    </div>
  );
}

export default App;
